const apiClient = endpoint => {
    const host = "https://us-central1-sixtynite.cloudfunctions.net";
    const customFetch = (
      url,
      method = "GET",
      body = false,
    ) => {
      const options = {
        method, 
      };
      if (body) options.body = JSON.stringify(body);
      return fetch(host+url, options)
        .then(response => { 
          return response.json(); 
        }).catch(err => {
          console.log(err);
          throw new Error(err);
        });
    };
    const get = (body = undefined) => {
      var params="";
      if (!body) throw new Error("to make a get you must provide a body");
          params = new URLSearchParams(body).toString();
      const url = `${endpoint}${params ? `?${params}` : ""}`;
      return customFetch(url);
    };
    const post = (body = undefined) => {
      if (!body) throw new Error("to make a post you must provide a body");
      return customFetch(endpoint, "POST", body);
    };
    const put = (id = false, body = false) => {
      if (!id || !body)
        throw new Error("to make a put you must provide the id and the body");
      const url = `${endpoint}/${id}`;
      return customFetch(url, "PUT", body);
    };
    const del = (id = false) => {
      if (!id)
        throw new Error("to make a delete you must provide the id and the body");
      const url = `${endpoint}/${id}`;
      return customFetch(url, "DELETE");
    };
    return {
      get,
      post,
      put,
      del
    };
};

export default apiClient;
